__turbopack_context__.v({
  "cards": "Y4Ztdq_cards",
  "content": "Y4Ztdq_content",
  "headContact": "Y4Ztdq_headContact",
  "p": "Y4Ztdq_p",
  "page-body-wrap": "Y4Ztdq_page-body-wrap",
  "pagehero": "Y4Ztdq_pagehero",
  "pageheropost": "Y4Ztdq_pageheropost",
  "pageheropre": "Y4Ztdq_pageheropre",
  "paragraph": "Y4Ztdq_paragraph",
  "paragraph-content": "Y4Ztdq_paragraph-content",
  "paragraph1": "Y4Ztdq_paragraph1",
  "phonecontent": "Y4Ztdq_phonecontent",
  "sectionCard": "Y4Ztdq_sectionCard",
  "store": "Y4Ztdq_store",
  "t": "Y4Ztdq_t",
  "title": "Y4Ztdq_title",
  "title1": "Y4Ztdq_title1",
  "wrap-container": "Y4Ztdq_wrap-container",
  "wrap-content": "Y4Ztdq_wrap-content",
});
